import { render, staticRenderFns } from "./HintText.vue?vue&type=template&id=22fb7c3e&"
import script from "./HintText.vue?vue&type=script&lang=ts&"
export * from "./HintText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports